import { css, styled } from '@mui/material';

export const StyledVerticalContent = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('LARGE')};
  `
);

export const StyledHintContainer = styled('div')(
  ({ theme }) => css`
    background-color: ${theme.palette.gray.light_gray};
    border-radius: 4px;
    padding: ${theme.spacing('LARGE')};
  `
);
